<template>
  <Box class="col-span-full md:col-span-4">
    <div class="flex h-full flex-col gap-2 md:gap-4">
      <CardLoaderSmall v-if="isLoading" class="flex-1 flex-col !p-0 !ring-0" />
      <template v-else>
        <h2 class="text-t4 mb-2 flex items-center gap-4">
          <IconLaundry class="w-[50px] h-[50px] md:w-[59px] md:h-[59px]" />
          Tvättstuga och lokaler
        </h2>
        <div
          v-if="hasValidApartmentContract && hasAnyBookableLocations"
          class="flex flex-1 flex-col"
        >
          <div v-if="bookingsFromToday.length > 0">
            <div class="flex justify-between items-center mb-2">
              <h3 class="text-b2">Bokningar</h3>
              <Button class="mb-1" variant="tertiary" :to="{ path: '/tvattstugan' }">
                Visa alla
                <template #icon-after>
                  <IconArrowRight />
                </template>
              </Button>
            </div>
            <div class="flex flex-row gap-1">
              <div
                v-for="booking in bookingsFromToday.slice(0, 3)"
                class="flex-1 rounded-[15px] border-l-4 border-solid border-yellow bg-primary-10 p-2 text-gray-dark"
              >
                <p class="mb-1 font-bold">{{ booking.GroupName }}</p>
                <p class="font-thick capitalize">
                  {{ niceDateFormat(booking.StartTimeStamp) }} kl
                  {{ formatTime(booking.StartTimeStamp, 0) }}-{{
                    formatTime(booking.StartTimeStamp, booking.LengthMinutes)
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-else class="flex h-20 flex-1 flex-col items-center justify-center gap-2 -mt-4">
            <IconCalendarBlank class="w-[46px] h-[46px] md:w-54px] md:h-[54px]" />
            <p class="text-center">Just nu har du ingen tid bokad.</p>
          </div>
        </div>
        <div v-else>
          <span v-if="!hasValidApartmentContract && !!contractsLoaded">
            Du har för närvarande inget aktivt hyresavtal hos Gavlegårdarna
          </span>
          <span v-else-if="!!loadingError">
            Just nu kan vi inte ladda dina tvättstugor
          </span>
          <span v-else-if="!!contractsLoaded">
            Du har tyvärr inte tillgång till någon tvättstuga som kan bokas via Mina sidor.
          </span>
        </div>
        <div class="mt-auto flex items-end justify-end">
          <Button :to="{ path: '/tvattstugan' }" size="large">Boka tid</Button>
        </div>
      </template>
    </div>
  </Box>
</template>

<script>
import Box from '@/components/ui/box';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import IconLaundry from '@/components/icons/IconLaundry';
import IconArrowRight from '@/components/icons/IconArrowRight';
import IconCalendarBlank from '@/components/icons/IconCalendarBlank';
import Button from '@/components/ui/button';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
  name: 'DashboardLaundry',
  props: {
    startLoading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CardLoaderSmall,
    Box,
    Button,
    IconArrowRight,
    IconLaundry,
    IconCalendarBlank,
  },
  data() {
    return {
      isLoading: true,
      loadingError: false,
      contractsLoaded: false,
      // testAlwaysLoading: true,
      validContracts: [],
    };
  },
  computed: {
    ...mapGetters({
      bookingsFromToday: 'bookingsFromToday',
      hasValidApartmentContract: 'hasValidApartmentContract',
      hasAnyBookableLocations: 'hasAnyBookableLocations',
      hasApartment: 'hasApartment',
      getApartments: 'getApartments',
      getBooking: 'getClosestBooking',
    }),
  },
  watch: {
    startLoading: {
      immediate: true,
      handler(val) {
        if (val === true) {
          this.loadingError = false;
          new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
            this.$store.cache.dispatch('fetchContracts')
              .then(() => {
                this.getApartments.forEach((el) => {
                  if (el.status !== 'coming' && el.status !== 'ceased' && el.status !== 'awaitingSignature') {
                    this.validContracts.push(el);
                    this.$store.cache
                      .dispatch('getBookingCategories', el.rentalObjectCode)
                      .then(() => {
                        this.$store.cache
                          .dispatch('getBookings', el.rentalObjectCode)
                          .finally(() => {
                            this.setDone();
                          });
                      }).catch((error) => {
                      this.setDone();
                      this.loadingError = true;
                      console.log('Failed to get booking categories:', error);
                    });
                  }
                });

                if(this.validContracts.length == 0) {
                  this.setDone();
                }
              })
              .catch((error) => {
                this.loadingError = true;
                this.setDone();
                console.log('Failed to fetch contracts:', error);
              })
              .finally(() => {

              });
          });
        }
      }
    },
  },
  created() {
  },

  methods: {
    setDone() {
      this.contractsLoaded = true;
      this.isLoading = false;
    },
    niceDateFormat(d) {
      return dayjs(d).format('ddd') + ' ' + dayjs(d).format('DD MMM');
    },
    formatTime(time, length) {
      return dayjs(time).add(length, 'minute').format('HH:mm');
    },
    formatDate(dateString) {
      return new Date(dateString).toISOString().split('T')[0];
    },
  },
};
</script>
